import React, { useState, useEffect, useContext } from 'react';
import CustomerFormModal from './CustomerFormModal'; // Assuming CustomerFormModal.jsx is in the same directory
import {Context} from './StockManagerContext';

export default function CustomerFormButton({ getMethods, startVisible = false }) {
    const { currentCustomer, setOpenCustomerForm } = useContext(Context);
    const [ openModal, setOpenModal ] = useState(_ => _);
    const [ buttonVisible, setVisible ] = useState(startVisible);


    useEffect(() => {
        getMethods({
            enable: () => {
                setVisible(true);
            }
        });
    }, []);

    return buttonVisible && (
        <>
            <a className={`btn ${currentCustomer ? 'btn-warning' : 'btn-light'} customer-form`} onClick={openModal} style={{ cursor: 'pointer' }}>
                <span className={currentCustomer ? "edit-contact" : "add-contact"}></span>
                {currentCustomer ? <span className="customer-name">{currentCustomer.Full_Name}</span> : ''}
            </a>
            <CustomerFormModal getMethods={methods => {
                setOpenModal(() => methods.open);
                setOpenCustomerForm(() => methods.open);
                console.log('CustomerForm', methods);
            }} />
        </>
    );
}
